/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Give_Our_Ai_Ghostwriter_The_Context_It_NeedsInputs */

const en_give_our_ai_ghostwriter_the_context_it_needs = /** @type {(inputs: Give_Our_Ai_Ghostwriter_The_Context_It_NeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give our AI ghostwriter the context it needs to create your story.`)
};

const es_give_our_ai_ghostwriter_the_context_it_needs = /** @type {(inputs: Give_Our_Ai_Ghostwriter_The_Context_It_NeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dale a nuestro escritor fantasma de IA el contexto que necesita para crear tu historia.`)
};

const fr_give_our_ai_ghostwriter_the_context_it_needs = /** @type {(inputs: Give_Our_Ai_Ghostwriter_The_Context_It_NeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donnez à notre prête-plume IA le contexte nécessaire pour créer votre histoire.`)
};

const de_give_our_ai_ghostwriter_the_context_it_needs = /** @type {(inputs: Give_Our_Ai_Ghostwriter_The_Context_It_NeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie unserem KI-Ghostwriter den Kontext, den er für Ihre Geschichte braucht.`)
};

const ja_give_our_ai_ghostwriter_the_context_it_needs = /** @type {(inputs: Give_Our_Ai_Ghostwriter_The_Context_It_NeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIゴーストライターにストーリー作成に必要なコンテキストを提供してください。`)
};

const zh_give_our_ai_ghostwriter_the_context_it_needs = /** @type {(inputs: Give_Our_Ai_Ghostwriter_The_Context_It_NeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为我们的AI代笔提供创建故事所需的背景信息。`)
};

const ar_give_our_ai_ghostwriter_the_context_it_needs = /** @type {(inputs: Give_Our_Ai_Ghostwriter_The_Context_It_NeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`امنح الكاتب الشبح بالذكاء الاصطناعي السياق الذي يحتاجه لإنشاء قصتك.`)
};

const id_give_our_ai_ghostwriter_the_context_it_needs = /** @type {(inputs: Give_Our_Ai_Ghostwriter_The_Context_It_NeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berikan konteks yang dibutuhkan ghostwriter AI kami untuk membuat cerita Anda.`)
};

const it_give_our_ai_ghostwriter_the_context_it_needs = /** @type {(inputs: Give_Our_Ai_Ghostwriter_The_Context_It_NeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornisci al nostro ghostwriter basato sull'IA il contesto di cui ha bisogno per creare la tua storia.`)
};

const ru_give_our_ai_ghostwriter_the_context_it_needs = /** @type {(inputs: Give_Our_Ai_Ghostwriter_The_Context_It_NeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дайте нашему ИИ-гострайтеру контекст, необходимый для создания вашей истории.`)
};

const pt_give_our_ai_ghostwriter_the_context_it_needs = /** @type {(inputs: Give_Our_Ai_Ghostwriter_The_Context_It_NeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dê ao nosso ghostwriter de IA o contexto necessário para criar a sua história.`)
};

const ko_give_our_ai_ghostwriter_the_context_it_needs = /** @type {(inputs: Give_Our_Ai_Ghostwriter_The_Context_It_NeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 대필 작가가 스토리를 작성하는 데 필요한 배경 정보를 제공해주세요.`)
};

/**
* | output |
* | --- |
* | "Give our AI ghostwriter the context it needs to create your story." |
*
* @param {Give_Our_Ai_Ghostwriter_The_Context_It_NeedsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const give_our_ai_ghostwriter_the_context_it_needs = /** @type {((inputs?: Give_Our_Ai_Ghostwriter_The_Context_It_NeedsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Give_Our_Ai_Ghostwriter_The_Context_It_NeedsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_give_our_ai_ghostwriter_the_context_it_needs(inputs)
	if (locale === "es") return es_give_our_ai_ghostwriter_the_context_it_needs(inputs)
	if (locale === "fr") return fr_give_our_ai_ghostwriter_the_context_it_needs(inputs)
	if (locale === "de") return de_give_our_ai_ghostwriter_the_context_it_needs(inputs)
	if (locale === "ja") return ja_give_our_ai_ghostwriter_the_context_it_needs(inputs)
	if (locale === "zh") return zh_give_our_ai_ghostwriter_the_context_it_needs(inputs)
	if (locale === "ar") return ar_give_our_ai_ghostwriter_the_context_it_needs(inputs)
	if (locale === "id") return id_give_our_ai_ghostwriter_the_context_it_needs(inputs)
	if (locale === "it") return it_give_our_ai_ghostwriter_the_context_it_needs(inputs)
	if (locale === "ru") return ru_give_our_ai_ghostwriter_the_context_it_needs(inputs)
	if (locale === "pt") return pt_give_our_ai_ghostwriter_the_context_it_needs(inputs)
	return ko_give_our_ai_ghostwriter_the_context_it_needs(inputs)
});